var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.333,
    height: 42.834,
    viewBox: "0 0 39.333 42.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_110",
    x: 0,
    y: 0,
    width: 22.832,
    height: 26.334,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.761
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_111",
    x: 16.501,
    y: 0,
    width: 22.832,
    height: 26.334,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.761
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_112",
    x: 0.001,
    y: 16.503,
    width: 22.831,
    height: 26.331,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.761
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_113",
    x: 16.502,
    y: 16.502,
    width: 22.831,
    height: 26.331,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.761
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_114",
    x: 7.837,
    y: 5.04,
    width: 13.003,
    height: 19.299,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.761
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_115",
    x: 24.34,
    y: 5.033,
    width: 13.002,
    height: 19.308,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.761
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_116",
    x: 7.837,
    y: 21.54,
    width: 13.003,
    height: 19.3,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.761
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_117",
    x: 19.808,
    y: 19.808,
    width: 16.219,
    height: 19.719,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.761
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_95",
    "data-name": "Groupe 95",
    transform: "translate(-140.375 -439.624)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 140.38, 439.62)",
    filter: "url(#Trac\\xE9_110)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_110-2",
    "data-name": "Trac\\xE9 110",
    d: "M158.706,446.541c0,1.182,0,2.364,0,3.547a3.3,3.3,0,0,1-3.368,3.368q-3.547.006-7.093,0a3.3,3.3,0,0,1-3.367-3.368q-.006-3.547,0-7.093a3.3,3.3,0,0,1,3.367-3.367q3.547-.006,7.093,0a3.3,3.3,0,0,1,3.368,3.367C158.709,444.176,158.706,445.358,158.706,446.541Zm-12.541-.041c0,1.21,0,2.419,0,3.629a1.976,1.976,0,0,0,2.026,2.037q3.588.009,7.176,0a1.977,1.977,0,0,0,2.048-2.057q.007-3.567,0-7.134a1.974,1.974,0,0,0-2.047-2.057q-3.567-.007-7.134,0a1.981,1.981,0,0,0-2.068,2.078C146.163,444.162,146.166,445.331,146.166,446.5Z",
    transform: "translate(-140.38 -439.62)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 140.38, 439.62)",
    filter: "url(#Trac\\xE9_111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_111-2",
    "data-name": "Trac\\xE9 111",
    d: "M308.707,446.541c0,1.182,0,2.364,0,3.547a3.3,3.3,0,0,1-3.368,3.367q-3.547.006-7.093,0a3.3,3.3,0,0,1-3.367-3.368q-.006-3.547,0-7.093a3.3,3.3,0,0,1,3.367-3.366q3.547-.006,7.093,0a3.3,3.3,0,0,1,3.367,3.367C308.709,444.177,308.707,445.359,308.707,446.541Zm-1.289.041c0-1.21,0-2.419,0-3.629a1.973,1.973,0,0,0-2.026-2.036q-3.588-.009-7.176,0a1.976,1.976,0,0,0-2.048,2.056q-.006,3.567,0,7.134a1.977,1.977,0,0,0,2.046,2.058q3.567.008,7.134,0a1.981,1.981,0,0,0,2.069-2.078C307.421,448.919,307.418,447.751,307.418,446.582Z",
    transform: "translate(-273.87 -439.62)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 140.38, 439.62)",
    filter: "url(#Trac\\xE9_112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_112-2",
    "data-name": "Trac\\xE9 112",
    d: "M158.717,596.561c0,1.182,0,2.364,0,3.547a3.3,3.3,0,0,1-3.374,3.361q-3.526.006-7.052,0a3.305,3.305,0,0,1-3.4-3.416q0-3.464,0-6.928a3.309,3.309,0,0,1,3.5-3.485h6.846a3.31,3.31,0,0,1,3.486,3.5Q158.717,594.85,158.717,596.561Zm-1.289.035c0-1.21,0-2.419,0-3.629a1.973,1.973,0,0,0-2.026-2.036q-3.588-.009-7.176,0a1.975,1.975,0,0,0-2.048,2.056q-.006,3.567,0,7.134a1.977,1.977,0,0,0,2.046,2.058q3.567.008,7.134,0a1.981,1.981,0,0,0,2.069-2.078C157.431,598.933,157.428,597.765,157.428,596.6Z",
    transform: "translate(-140.39 -573.14)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 140.38, 439.62)",
    filter: "url(#Trac\\xE9_113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_113-2",
    "data-name": "Trac\\xE9 113",
    d: "M294.886,596.564c0-1.182,0-2.364,0-3.547a3.3,3.3,0,0,1,3.394-3.382q3.485,0,6.969,0a3.308,3.308,0,0,1,3.466,3.476q0,3.423,0,6.846a3.313,3.313,0,0,1-3.518,3.507h-6.8a3.313,3.313,0,0,1-3.507-3.518Q294.886,598.255,294.886,596.564Zm12.541-.015c0-1.2,0-2.392,0-3.588a1.973,1.973,0,0,0-2.026-2.036q-3.588-.009-7.176,0a1.975,1.975,0,0,0-2.047,2.056q-.006,3.567,0,7.134a1.977,1.977,0,0,0,2.046,2.058q3.567.008,7.134,0a1.981,1.981,0,0,0,2.069-2.078C307.43,598.914,307.427,597.732,307.427,596.55Z",
    transform: "translate(-273.88 -573.13)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 140.38, 439.62)",
    filter: "url(#Trac\\xE9_114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_114-2",
    "data-name": "Trac\\xE9 114",
    d: "M220.108,485.474c0,.133,0,.265,0,.4q.007,2.387.013,4.774c0,1.115-.484,1.593-1.613,1.59-.765,0-1.531,0-2.3,0l-.094-.111,3.858-6.687Z",
    transform: "translate(-203.78 -480.4)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 140.38, 439.62)",
    filter: "url(#Trac\\xE9_115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_115-2",
    "data-name": "Trac\\xE9 115",
    d: "M370.129,485.423q0,1.211,0,2.421c0,.974.011,1.948.005,2.922a1.327,1.327,0,0,1-1.418,1.412c-.832.006-1.664,0-2.5,0l-.085-.117L370,485.373Z",
    transform: "translate(-337.29 -480.34)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 140.38, 439.62)",
    filter: "url(#Trac\\xE9_116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_116-2",
    "data-name": "Trac\\xE9 116",
    d: "M220.09,635.469c.006.119.017.239.018.358q.009,2.449.014,4.9a1.342,1.342,0,0,1-1.49,1.507h-2.419l-.094-.112,3.858-6.687Z",
    transform: "translate(-203.78 -613.89)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 140.38, 439.62)",
    filter: "url(#Trac\\xE9_117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_117-2",
    "data-name": "Trac\\xE9 117",
    d: "M327.9,623.939c-.771,0-1.471,0-2.17,0-.489,0-.8-.257-.795-.644s.306-.639.8-.642c.7,0,1.4,0,2.169,0v-1.027c0-.343,0-.687,0-1.03,0-.594.234-.917.654-.909s.633.325.634.929c0,.658,0,1.315,0,2.036h1.736c.179,0,.357-.007.535,0a.664.664,0,0,1,.693.621.656.656,0,0,1-.693.661c-.631.013-1.263,0-1.895.005-.107,0-.215.01-.377.018v1.358c0,.233,0,.467,0,.7,0,.566-.228.881-.635.888s-.652-.312-.653-.869,0-1.1,0-1.648Z",
    transform: "translate(-300.63 -599.88)",
    fill: "#50b2dc"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIconBlue);
export default __webpack_public_path__ + "static/media/grid-icon-blue.ef73afec7dffdd92986df9d7efc0610a.svg";
export { ForwardRef as ReactComponent };